import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const sessionInformation202410: BlogMetaData = {
  title: '2024年10月の見学会開催について',
  description:
    '今年度及び来年度の園児募集につき、園の見学会を開催します。モンテッソーリのお仕事の見学と質疑応答を行います',
  thumbnailUrl: '/img/first-view-image1.webp',
  filePath: buildBlogFilePath('2024_10-session-information'),
  category: BLOG_CATEGORY.NEWS,
};
